import { RootState } from 'src/store/reduxTypes';
import { ClientPreviewSteps, CoachmarkTourKey } from 'src/store/ui/types';

export const selectCoachmarkActive =
  (key: CoachmarkTourKey) =>
  (state: RootState): boolean =>
    state.ui.coachmark[key]?.active ?? false;

export const selectCoachmarkCompleted =
  (key: CoachmarkTourKey) =>
  (state: RootState): boolean =>
    state.ui.coachmark[key]?.completed ?? false;

export const selectIsStudioClientPreview = (state: RootState): boolean =>
  state.ui.isStudioClientPreview;

export const selectStudioClientPreviewProgress = (state: RootState): number =>
  state.ui.studioClientPreviewProgress;

export const selectClientPreviewSteps = (
  state: RootState,
): ClientPreviewSteps | null => state.ui.clientPreviewSteps;

export const selectGettingStartedCompletedOnLoad = (
  state: RootState,
): boolean | null => state.ui.gettingStartedCompletedOnLoad;

export const selectIsUnlockCardShowing = (state: RootState): boolean =>
  state.ui.isUnlockCardShowing;
